import { Component, OnInit } from '@angular/core';
import { Spanish } from 'flatpickr/dist/l10n/es';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { RestService } from '../rest.service';
import { UserService } from '../user.service';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { AcuerdosService } from '../acuerdos.service';

@Component({
  selector: 'app-crear-acuerdo',
  templateUrl: './crear-acuerdo.component.html',
  styleUrls: ['./crear-acuerdo.component.scss']
})
export class CrearAcuerdoComponent implements OnInit {

  
  //GENERICO
  proveedores:any[] = [];
  articulos:any[] = [];

  // ACUERDO
  proveedor_id: string = '';
  articulo_id: string = '';

  aportacion: number = 0;
  unidades: number = 0;

  inicio: string = new Date().toISOString().slice(0, 10);
  dateTimeInicio: FlatpickrOptions = {
    enableTime: false,
    dateFormat: 'Y-m-d',
    locale: Spanish,
    onChange: (selectedDates, dateStr, instance) => this.inicio = dateStr
  };

  limite: string = new Date().toISOString().slice(0, 10);
  dateTimeLimite: FlatpickrOptions = {
    enableTime: false,
    dateFormat: 'Y-m-d',
    locale: Spanish,
    onChange: (selectedDates, dateStr, instance) => this.limite = dateStr
  };

  // AÑADIDOS
  proveedor_id_a: string = '';
  articulo_id_a: string = '';
  unidades_a: number = 0;


  // NEW
  cart: any[] = [];

  //ARTICULOS
  articulo = {
    'index' : '0',
    'nombre' : '',
    'unidades' : '',
    'aportacion' : ''
  };

  constructor(
    public rest: RestService,
    public acuerdosService: AcuerdosService,
    public user: UserService) { }

  ngOnInit() { this.GetFamilias(); }

  InsertarEnCarrito() {
    this.cart.push({
      'id' : this.articulos[this.articulo.index].IdPack,
      'nombre' : this.articulos[this.articulo.index].Nombre,
      'unidades' : this.articulo.unidades,
      'aportacion' : this.articulo.aportacion
    });
  }

  Guardar() {
    this.rest.CrearAcuerdo(this.proveedor_id,this.inicio,this.limite).subscribe(
      (data) => {

      this.cart.forEach(reg => {
        this.rest.CrearArticuloAcuerdo(reg.id, reg.aportacion, reg.unidades,data['data']['id'])
        .subscribe(
          () => { this.cart.length = 0; });
      });
      this.user.PublicMsg(data);
      }, (error) =>  this.user.PublicError(error) );
  }

  BorrarCarrito(index) { this.cart.splice(index, 1); }

  CrearAcuerdo() {
    this.rest.CrearAcuerdo(this.proveedor_id, this.inicio, this.limite)
    .subscribe((data) => {
      this.articulo_id = '';
      this.proveedor_id = '';
      this.aportacion = 0;
      this.unidades = 0;
      this.user.PublicMsg(data);
    }, (error) => {
      this.articulos = [];
      this.user.PublicError(error);
    } );
  }

  Valores() {
    this.rest.Añadir(this.articulo_id_a, this.unidades_a)
    .subscribe((data) => {
      this.articulo_id_a = '';
      this.proveedor_id_a = '';
      this.unidades_a = 0;
      this.user.PublicMsg(data);
    }, (error) => {
      this.articulos = [];
      this.user.PublicError(error);
    } );
  }

  GetArticulosPorFamilia() {
    this.rest.getArticulosPorProveedor(this.proveedor_id).subscribe((data) => {
      this.articulos = data['data'];
    }, (error) => this.articulos = [] );
  }

  GetFamilias() {
    this.rest.getProveedores().subscribe ((data) => {
      this.proveedores = data['data'];
    }, (error) => this.proveedores = [] );
  }

}
